import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Quote } from 'lucide-react';

export const ScriptureCard = ({ card, className = '' }) => {
  if (!card) return null;

  return (
    <Card className={`scripture-card overflow-hidden ${className}`} data-testid="scripture-card">
      <CardContent className="p-6 relative">
        <Quote className="h-8 w-8 text-primary/20 absolute top-4 left-4" />
        
        <div className="relative z-10 pt-6">
          <Badge variant="secondary" className="mb-4">
            {card.theme}
          </Badge>
          
          <blockquote className="font-serif text-xl leading-relaxed mb-4 italic text-foreground">
            "{card.verse}"
          </blockquote>
          
          <p className="text-sm font-medium text-primary mb-4">
            — {card.reference}
          </p>
          
          <div className="pt-4 border-t border-border">
            <p className="text-muted-foreground leading-relaxed">
              {card.affirmation}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ScriptureCard;
